import {useLocation} from "react-router-dom";
import Navbar from "components/helpers/nav/bar";
import useAppContext from "lib/hooks/use-app-context";

const nestedRoutes = [
  {
    field: "manage_cases",
    key: "cases",
    home: {name: "Cases", path: "/admin/cases"},
    links: [
      {name: "Authors", path: "/admin/authors"},
      {name: "Cases", path: "/admin/cases"},
      {name: "Reviewers", path: "/admin/reviewers"},
      {name: "Submissions", path: "/admin/case-submissions"}
    ]
  },
  {
    field: "manage_content",
    key: "content",
    home: {name: "Content", path: "/admin/sections"},
    links: [
      {name: "Articles", path: "/admin/articles"},
      {name: "Categories", path: "/admin/article-categories"},
      {name: "Content", path: "/admin/sections"},
      {name: "Newsletters", path: "/admin/newsletters"},
      {name: "Pages", path: "/admin/pages"}
    ]
  },
  {
    field: "manage_podcast",
    key: "podcast",
    home: {name: "Podcast", path: "/admin/channels"},
    links: [
      {name: "Channels", path: "/admin/channels"},
      {name: "Episodes", path: "/admin/episodes"},
      {name: "Posts", path: "/admin/posts"}
    ]
  },
  {
    field: "manage_store",
    key: "store",
    home: {name: "Store", path: "/admin/orders"},
    links: [
      {name: "Orders", path: "/admin/orders"},
      {name: "Products", path: "/admin/products"}
    ]
  },
  {
    field: "manage_all",
    key: "other",
    home: {name: "Other", path: "/admin/messages"},
    links: [
      {name: "Messages", path: "/admin/messages"},
      {name: "Stats", path: "/admin/stats"},
      {name: "Uploads", path: "/admin/uploads"},
      {name: "Users", path: "/admin/users"}
    ]
  }
];

export default function AdminNavbar() {
  const {user} = useAppContext();
  const {pathname} = useLocation();
  const enabledRoutes = user
    ? nestedRoutes.filter(({field}) => user.manage_all || user[field])
    : [];
  const secondaryRoutes = enabledRoutes
    .filter(({links}) => links.some(({path}) => pathname.startsWith(path)));
  const enabledLinks = enabledRoutes.map(({key, home}) => ({
    active: secondaryRoutes.some((routes) => routes.key === key),
    ...home
  }));

  return (
    <>
      <Navbar key="admin" home={{name: "Admin", path: "/admin"}} links={enabledLinks} />
      {secondaryRoutes.map(({key, home, links}) => (
        <Navbar key={key} color="secondary" home={home} links={links} />
      ))}
    </>
  );
}
